<template>
  <v-row class='ma-0' align="center" :class="{ 'justify-center': !$vuetify.breakpoint.mdAndUp }">
    <slot name="left-prepend"/>
    <play-pause-btn-global/>
    <slot name="voice-select"><voice-select-global/></slot>
    <tts-mode-btn-global/>
    <slot name="speed-slider"><speed-slider-popper-global/></slot>
    <slot name="left"></slot>
    <v-spacer v-if='$vuetify.breakpoint.mdAndUp'/>
    <slot name="right"></slot>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue';
import PlayPauseBtnGlobal from './PlayPauseBtnGlobal.vue';
import VoiceSelectGlobal from './VoiceSelectGlobal.vue';
import TtsModeBtnGlobal from './TTSModeBtnGlobal.vue';
import SpeedSliderPopperGlobal from './SpeedSliderPopperGlobal.vue';

export default defineComponent({
  components: {
    VoiceSelectGlobal,
    TtsModeBtnGlobal,
    PlayPauseBtnGlobal,
    SpeedSliderPopperGlobal
  }
})
</script>
